import Header from "./partials/Header";
import Footer from "./partials/Footer";
import Slider from "./modules/Slider";
import Tabs from "./modules/Tabs";
import Counter from "./modules/Counter";
import Accordion from "./modules/Accordion";
import PriceTable from "./modules/PriceTable";
import Certificates from "./partials/Certificates";
import IncomingInvoice from "./modules/IncomingInvoice";
import LottiePlayer from "./modules/LottiePlayer";
import Policy from "./partials/Policy";
import CustomerPagiation from "./modules/CustomerPagiation";
import Actived from "./modules/Actived";
import scrollToID from "./modules/scrollToID";

new Header().init();
new Footer().init();
new Slider().init();
new Tabs().init();
new Counter().init();
new Accordion().init();
new PriceTable().init();
new Certificates().init();
new IncomingInvoice().init();
new LottiePlayer().init();
new Policy().init();
new CustomerPagiation().init();
new Actived().init();
new scrollToID().init();